import { render } from "./ColorCodeTab.vue?vue&type=template&id=642add98&scoped=true"
import script from "./ColorCodeTab.vue?vue&type=script&lang=js"
export * from "./ColorCodeTab.vue?vue&type=script&lang=js"

import "./ColorCodeTab.vue?vue&type=style&index=0&id=642add98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-642add98"

export default script